import { jsx } from 'react/jsx-runtime';
import { useContext, createContext } from 'react';

const defaultState = {
    userLoggedInText: 'Go to the dashboard',
    learnMoreText: 'Learn more',
    tagCategories: {
        academy: 'Academy',
        blog: 'Blog',
        community: 'Community',
        event: 'Event',
        guide: 'Guide',
        'help-center': 'Help center',
        news: 'News',
        template: 'Template',
        'use-case': 'Use case',
        'whats-new': "What's new"
    },
    cursors: {
        homepageHeroCursor1: 'Miro AI',
        homepageHeroCursor2: 'Rad',
        homepageHeroCursor3: 'Roger'
    }
};
const TextTokensContext = /*#__PURE__*/ createContext(defaultState);
const TextTokensProvider = ({ children, initialState })=>{
    return jsx(TextTokensContext.Provider, {
        value: initialState,
        children: children
    });
};
const useTextTokens = ()=>{
    return useContext(TextTokensContext);
};

export { TextTokensProvider, useTextTokens };
